(ns app.front.view.admin.commands
  (:require [app.domain.workspace.model :as workspace-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.ui.separator :as ui-sep]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.admin.commands.query-analyzer :as query-analyzer]
            [app.front.view.admin.freshdesk :as freshdesk]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx
  ::success
  (fn [_ _]
    {:dispatch [:notifications/add :toast :success :success "Command executed"]}))

(rf/reg-event-fx
  ::done
  (fn [_ [_ status]]
    {:dispatch [:notifications/add :toast
                (if (= status 304) :warning :error)
                (if (= status 304) :warning/warning :error/error)
                (cond (= status 304) "No changes made"
                      (= status 500) "Something went wrong"
                      :else "Error")]}))

(rf/reg-event-fx
  ::add-shapes-for-locations
  (fn [_ _]
    {:comm/command {:command    :admin/add-shapes-for-locations
                    :method     :post
                    :on-success [::success]
                    :on-done    [::done]}}))

(rf/reg-event-fx
  ::add-cashier-groups-n-auths-for-windsor
  (fn [_ _]
    {:comm/command {:command    :admin/add-cashier-groups-n-auths-for-windsor
                    :method     :post
                    :on-success [::success]
                    :on-done    [::done]}}))

(rf/reg-event-fx
  ::add-cashier-groups-to-auth-groups
  (fn [_ _]
    {:comm/command {:command :admin/add-cashier-role-to-auth-groups
                    :method  :post
                    :notify  {:success      "Migration to add Cashiers started, check logs for progress. Do not restart."
                              :not-modified "No changes made"}}}))

(rf/reg-event-fx
  ::add-reporting-groups-to-domain-groups
  (fn [_ _]
    {:comm/command {:command :admin/add-reporting-groups-to-domain-groups
                    :method  :post
                    :notify  {:success      "Migration to add reporting groups started, check logs for progress. Do not restart."
                              :not-modified "No changes made"}}}))

(rf/reg-event-fx
  ::fetch-public-holidays
  (fn [_ _]
    {:comm/command {:command :admin/fetch-public-holidays-for-all
                    :method  :post
                    :notify  {:success      "Fetching of public holidays started, check log for progress"
                              :not-modified "No changes made"}}}))

(rf/reg-event-fx
  ::add-form-field-index
  (fn [_ _]
    {:comm/command {:command :admin/add-form-field-index
                    :method  :post
                    :notify  {:success      "Form-field migration started, check log for progress"
                              :not-modified "No changes made"}}}))


(rf/reg-event-fx ::call-admin-operation
  (fn [_ [_ command data success-notification not-modified-notification]]
    {:comm/command (p/assoc-if {:command command
                                :method  :post
                                :notify  (p/assoc-if {:success success-notification}
                                                     :not-modified not-modified-notification)}
                               :data data)}))


(rf/reg-sub ::view-data
  (fn [_ _]
    {:alerts [[:high "Please read the instructions"]]}))


(defn button [tr item]
  [ui/modal-confirmation-button
   {:trigger-button-opts {:kind     :danger
                          :icon     i/warning
                          :size     :field
                          :disabled (boolean (:disabled? item))}
    :trigger-button-text (tr [(:text item)])
    :on-yes-click        #(>evt (:evt item))
    :tr                  tr
    :id                  (:id item)}
   (tr [:admin/execute-command])])

(defn description [tr item]
  [:p.pt-4 (tr [(:description item)])])

(def indexes-with-full-reindex-impl
  [:elastic.index/business
   :elastic.index/complaint
   :elastic.index/contractor-registration
   :elastic.index/licence
   :elastic.index/model-code-alt-text
   :elastic.index/property
   :elastic.index/workspace])

(defn elasticsearch-ops [tr]
  [:section
   [:div.mb-4.-ml-1
    [:img {:src   "/asset/img/elasticsearch.svg"
           :alt   "Elasticsearch operations"
           :style {:width "250px"}}]]

   [:h3.mt-6 "Workspace ops"]
   (r/with-let [*workspace-id (r/atom nil)]
     [:div.flex.items-end
      [:div.w-1-2.mr-3
       [ui/text-input {:id          "entity-lookup-id"
                       :light       true
                       :value       @*workspace-id
                       :on-change   #(reset! *workspace-id (futil/tval %))
                       :placeholder (tr [:placeholder/application-id])
                       :label-text  (tr [:admin.audit-log/workspace-id])}]]
      (cc/button {:kind     :primary
                  :disabled (not (workspace-model/workspace-id? @*workspace-id))
                  :size     :field
                  :on-click #(>evt [::call-admin-operation
                                    :admin/reindex-workspace
                                    {:workspace-id @*workspace-id}
                                    "Workspace reindexed, check log for info"])}
                 "Reindex single workspace")])
   [:div.flex.flex-wrap.mt-8.gap-4
    [button tr {:id   "clear-workspace-index"
                :evt  [::call-admin-operation
                       :admin/clear-workspace-index
                       nil
                       "Workspace clearing started, check log for progress"]
                :text "Clear workspace index"}]]

   [ui-sep/horizontal-line]
   [:h3.mt-6 "Full reindexing"]
   (r/with-let [*selected-idx (r/atom nil)]
     [:div.flex
      [:div.flex.gap-4.justify-start.items-end
       [ui-select/select {:id           "entity-lookup-id"
                          :class-name   "full-width-select"
                          :value        @*selected-idx
                          :values       (sort indexes-with-full-reindex-impl)
                          :on-change    #(reset! *selected-idx %)
                          :allow-empty? false
                          :label-text   "Elasticsearch index"}]
       [:div
        [ui/modal-confirmation-button
         {:trigger-button-opts {:kind     :danger
                                :icon     i/warning
                                :size     :field
                                :disabled (nil? @*selected-idx)}
          :trigger-button-text "Reindex all"
          :on-yes-click        #(>evt [::call-admin-operation
                                       :admin/reindex-elastic-index
                                       {:index @*selected-idx}
                                       (str "Full " @*selected-idx " reindexing started, check log for progress")])
          :tr                  tr
          :id                  "reindex-all-workspaces"}
         (str "Are you sure you want to reindex all " @*selected-idx " entities?")]]]])

   [ui-sep/horizontal-line]
   [:h3.mt-6 "Form field ops"]
   [:div.flex.flex-wrap.mt-8.gap-4
    [button tr {:id   "reindex-all-form-field-defs"
                :evt  [::call-admin-operation
                       :admin/reindex-all-form-field-defs
                       nil
                       "Form field definition reindexing started, check log for progress"]
                :text "Reindex all form field definitions"}]]

   [ui-sep/horizontal-line]
   [:h3.mt-6 "Property ops"]
   (r/with-let [*property-db-id (r/atom nil)]
     [:div.flex.items-end
      [:div.flex.gap-4.justify-start.items-end
       [ui/number-input {:id          "property-id"
                         :light       true
                         :value       @*property-db-id
                         :on-change   #(reset! *property-db-id (-> % futil/tval futil/parse-int))
                         :placeholder (tr [:placeholder/db-id])
                         :label-text  (tr [:property/db-id])}]
       (cc/button {:kind     :primary
                   :size     :field
                   :disabled (not (number? @*property-db-id))
                   :on-click #(>evt [::call-admin-operation
                                     :admin/reindex-property
                                     {:property-id @*property-db-id}
                                     "Property reindexed, check log for info"])}
                  "Reindex single property")]])])

(defn datomic-ops [tr]
  [:section
   [:div.mb-4
    [:img {:src   "/asset/img/datomic.png"
           :alt   "Datomic operations"
           :style {:height "80px"}}]]
   [:div.flex.flex-wrap
    [:div.mt-4.mr-3
     [button tr {:id   "excise-deprecated-attrs"
                 :evt  [::call-admin-operation
                        :admin/excise-deprecated-attrs
                        nil
                        "Data excising started. See transactor logs & CPU usage to determine progress."]
                 :text "Excise deprecated attributes"}]]
    [:div.mt-4
     [button tr {:id   "datomic-gc-storage"
                 :evt  [::call-admin-operation
                        :admin/datomic-gc-storage
                        nil
                        "Storage garbage collection started. See transactor logs for progress."]
                 :text "Start garbage collection"}]]]])

(defn postgresql-ops [tr]
  [:section
   [:div.mb-4
    [:img {:src   "/asset/img/postgresql.svg"
           :alt   "PostgreSQL operations"
           :style {:height "80px"}}]]
   [:div.lg:w-2-3 "Vacuuming frees SQL storage disk space. Full vacuum will completely rewrite the table used by Datomic on the disk "
    "and lock the database while vacuum is in progress and thus disconnect the Datomic peer from it. Regular vacuum will not lock the db."]
   [:div.flex.flex-wrap
    [:div.mt-4.mr-3
     [button tr {:id   "vacuum-full-postgresql-storage"
                 :evt  [::call-admin-operation
                        :admin/vacuum-postgresql-storage
                        {:full? true}
                        "PostgreSQL VACUUM FULL started. See Cloud SQL and vaahtera logs for progress."]
                 :text "Vacuum PostgreSQL table with full rewrite"}]]
    [:div.mt-4.mr-3
     [button tr {:id   "vacuum-postgresql-storage"
                 :evt  [::call-admin-operation
                        :admin/vacuum-postgresql-storage
                        {:full? false}
                        "PostgreSQL VACUUM started. See Cloud SQL and vaahtera logs for progress."]
                 :text "Vacuum PostgreSQL table"}]]]])

(defn storage-ops [tr]
  (r/with-let [*old-bucket-name (r/atom nil)
               *bucket-kind     (r/atom nil)]
    [:section
     [:div.mb-4.-ml-1
      [:img {:src   "/asset/img/cloud_storage.svg"
             :alt   "Storage operations"
             :style {:width "80px"}}]]
     [:p.lg:w-2-3 "Use Google " [:a {:href       "https://console.cloud.google.com/transfer/jobs"
                                     :aria-label "Storage Transfer link"} "Storage Transfer"]
      " service to copy the contents of a GCS bucket to a new bucket before using this tool. After the transfer is "
      "ready, use this tool to update :entity/file-bucket in Datomic entities to point to the new bucket.
      The new bucket name will be based on the current environment configuration and the selected bucket kind, so "
      "make sure that the software is currently using the correct bucket for any new file objects."]
     [:div.flex.items-end.lg:w-2-3
      [:div.w-1-3.mr-3
       [ui/text-input {:id          "olg-bucket-name"
                       :value       @*old-bucket-name
                       :on-change   #(reset! *old-bucket-name (futil/tval %))
                       :placeholder "evolve-ca-dev-application-files"
                       :label-text  "Old bucket name"}]]
      [:div.w-1-3.mr-3
       [ui-select/select {:id           "bucket-kind"
                          :value        @*bucket-kind
                          :class-name   "full-width-select"
                          :values       [:workspace
                                         :group
                                         :unlinked
                                         :licence
                                         :cr]
                          :val->str     name
                          :on-change    #(reset! *bucket-kind %)
                          :label-text   "Bucket kind"
                          :allow-empty? false}]]
      [ui/modal-confirmation-button {:trigger-button-opts {:kind     :primary
                                                           :disabled (not (and @*old-bucket-name @*bucket-kind))
                                                           :size     :field}
                                     :trigger-button-text "Update file entities"
                                     :on-yes-click        #(>evt [::call-admin-operation
                                                                  :admin/update-bucket-name
                                                                  {:bucket-kind     @*bucket-kind
                                                                   :old-bucket-name @*old-bucket-name}
                                                                  "Migration started, check application log to see progress."])
                                     :tr                  tr}
       [:div
        (str "Confirm that you have transferred the GCS bucket contents to the new bucket and want to update all "
             (some-> @*bucket-kind name) " file entities with the current bucket name " @*old-bucket-name " to be "
             "accessed from the new bucket.")]]]]))

(defn command-link [view-tag text]
  [:li.mb-2 [:a {:href       (href/href view-tag)
                 :aria-label (str text " link")}
             text]])

(defn- tools-view []
  [:section
   [:div.bg-ui-light-gray.p-4.rounded-md.mb-4
    [:a {:href       (href/href :view/admin.commands.query)
         :aria-label "Execute pre-defined queries link"} "Execute pre-defined queries"]]
   [:ul
    (when (ff/enabled? :feature-flag.id/icc-cloudcheck-prototype)
      [command-link :view/admin.commands.building-code-import ((<sub [:tr]) [:admin-building-code/heading])])
    [command-link :view/admin.commands.regenerate-pdf "Restart PDF generation"]
    [command-link :view/admin.commands.remove-user-from-ws "Remove user from workspace and groups"]
    [command-link :view/admin.commands.user-integrations "Manage user integrations"]
    [command-link :view/admin.commands.change-workspace-municipality "Change workspace municipality"]
    [command-link :view/admin.commands.add-workspace-execution-phase "Add work phase to workspace"]
    [command-link :view/admin.commands.unlock-tasks "Unlock tasks"]
    [command-link :view/admin.commands.authorize-sibling-groups "Authorize sibling groups"]
    [command-link :view/admin.commands.workspace-delete "Delete workspace"]
    [command-link :view/admin.commands.workspace-restore "Restore deleted workspace"]
    [command-link :view/admin.commands.business-delete "Delete unused business"]
    [command-link :view/admin.commands.data-import-repair "Repair data import"]
    [command-link :view/admin.commands.unblock-data-import "Unblock data import"]
    [command-link :view/admin.commands.remove-orphaned-business-imports "Remove orphaned business records from a removed data import"]
    [command-link :view/admin.commands.fix-assessment-reports "Fix stuck assessment reports"]
    [command-link :view/admin.commands.delete-orphaned-registrations "Delete licences or contractor registrations without a workspace"]
    [command-link :view/admin.commands.migrate-cr-trades "Migrate contractor registration trades"]
    [command-link :view/admin.commands.change-config-path "Change category/work type/work target for a workspace"]
    [command-link :view/admin.commands.remove-duplicate-entities "Remove accidentally created duplicate entities."]
    [command-link :view/admin.commands.remove-duplicate-user "Remove duplicate user."]
    [command-link :view/admin.commands.repair-cancelled-visit-booking "Repair cancelled inspection visit booking"]
    [command-link :view/admin.commands.dedupe-embeddings "Dedupe vector database embeddings"]
    [command-link :view/admin.migration.change-user-domain "Change username / email domain for all matching users"]
    [command-link :view/admin.migration.change-licence-number "Change license number for (re-)issued license"]
    [command-link :view/admin.migration.restrict-workspaces-for-sibling-groups "Restrict workspace visibility for sibling groups"]
    [command-link :view/admin.commands.review-acceptances "Review acceptances browser"]
    [command-link :view/admin.commands.delete-ag-entity "Delete an authority group entity and all related entities"]
    [command-link :view/admin.commands.create-inspection-groups "Create inspection groups"]
    [command-link :view/admin.commands.mass-delete-domain-group-properties "Mass-delete domain group properties without important information"]]])

(defn- one-time-migrations-table [tr]
  [:section
   [ui-table/modern-responsive-table
    {:items       [{:id          "add-reporting-groups-to-domain-groups"
                    :evt         [::add-reporting-groups-to-domain-groups]
                    :description "Adds reporting groups to all domain groups which don't already have it."
                    :text        "Execute"}
                   {:id          "add-cashier-groups-to-auth-groups"
                    :evt         [::add-cashier-groups-to-auth-groups]
                    :description "Adds cashier groups and authorizations for all authority which doesn't already have it."
                    :text        "Execute"}
                   {:id          "add-cashier-groups-n-auths-for-windsor"
                    :evt         [::add-cashier-groups-n-auths-for-windsor]
                    :description "Adds cashier groups and authorizations for Windsor B/P/PW that don't already have it"
                    :text        "Execute"}
                   {:id          "add-shapes-for-locations"
                    :evt         [::add-shapes-for-locations]
                    :description "Adds geometry shapes from GIS for property locations"
                    :text        "Execute"}
                   {:id          "fetch-public-holidays"
                    :evt         [::fetch-public-holidays]
                    :description "Generate blackouts from public holidays from Holiday API for all authority groups"
                    :text        "Execute"}
                   {:id          "migrate-form-field-unique-tuple"
                    :evt         [::add-form-field-index]
                    :description "Migrate new form-field unique index tuple to all form-field entities"
                    :text        "Execute"}
                   {:id          "add-workspace-created-timestamp"
                    :evt         [::call-admin-operation
                                  :admin/add-workspace-created-timestamp
                                  nil
                                  ":workspace/created migration started, check logs for progress."]
                    :description "Add :workspace/created indexed timestamp for workspaces"
                    :text        "Execute"}
                   {:id          "add-form-field-label-and-inactive"
                    :evt         [::call-admin-operation
                                  :admin/add-form-field-label-and-inactive
                                  nil
                                  ":form.field/label and :form.field/inactive attribute migration started, check logs for progress."]
                    :description "Add :form.field/label and :form.field/inactive attributes for existing fields"
                    :text        "Execute"}
                   {:id          "recreate-dw-sql-views"
                    :evt         [::call-admin-operation
                                  :admin/recreate-dw-sql-views
                                  nil
                                  "SQL views recreated"]
                    :description "Recreate DW SQL views (when updated in vaahtera resources) for analytics"
                    :text        "Execute"}
                   {:id          "add-domain-group-admins"
                    :evt         [::call-admin-operation
                                  :admin/add-existing-admins-as-domain-admins
                                  nil
                                  "Domain group administrator migration started, check logs for progress. Do not restart."]
                    :description "Add all authority group admins as admins in their domain group"
                    :text        "Execute"}
                   {:id          "add-booking-tuple-indices"
                    :evt         [::call-admin-operation
                                  :admin/add-booking-tuple-indices
                                  nil
                                  "Booking tuple index migration started, check logs for progress. Do not restart."]
                    :description "Add tuple indices to bookings for faster lookups"
                    :text        "Engage"}
                   {:id          "add-property-group"
                    :evt         [::call-admin-operation
                                  :admin/add-property-group
                                  nil
                                  "Property group migration started, check logs for progress. Do not restart."]
                    :description "Add domain group reference to property entities and split properties in Canada"
                    :text        "Engage"}
                   {:id          "add-property-state"
                    :evt         [::call-admin-operation
                                  :admin/add-property-state
                                  nil
                                  "Property state migration started, check logs for progress. Do not restart."]
                    :description "Add domain/state to property entities"
                    :text        "Execute"}
                   {:id          "add-inspection-visit-type"
                    :evt         [::call-admin-operation
                                  :admin/add-inspection-visit-type
                                  nil
                                  "Inspection visit type migration started, check logs for progress. Do not restart."]
                    :description "Add configured visit type to all inspections"
                    :text        "Engage"}
                   {:id          "add-inspection-visit-result"
                    :evt         [::call-admin-operation
                                  :admin/add-inspection-visit-result
                                  nil
                                  "Inspection visit result migration started, check logs for progress. Do not restart."]
                    :description "Add configured visit result to all inspection visits with an enumerated result"
                    :text        "Engage"}
                   {:id          "admin/add-qualifications-to-inspection-template-kind"
                    :evt         [::call-admin-operation
                                  :admin/add-qualifications-to-inspection-template-kind
                                  nil
                                  "Inspection template kind qualification migration started, check logs for progress. Do not restart."]
                    :description "Add configured qualifications to all inspection template kinds with enumerated qualifications"
                    :text        "Engage"}
                   {:id          "admin/add-qualifications-to-inspection"
                    :evt         [::call-admin-operation
                                  :admin/add-qualifications-to-inspection
                                  nil
                                  "Inspection qualification migration started, check logs for progress. Do not restart."]
                    :description "Add configured qualifications to all inspections with enumerated qualifications"
                    :text        "Engage"}
                   {:id          "admin/add-qualifications-to-group"
                    :evt         [::call-admin-operation
                                  :admin/add-qualification-to-group
                                  nil
                                  "Group qualification migration started, check logs for progress. Do not restart."]
                    :description "Add configured qualification to all groups with enumerated qualification"
                    :text        "Engage"}
                   {:id          "admin/add-missing-templates-to-supergroups"
                    :evt         [::call-admin-operation
                                  :admin/add-missing-templates-to-supergroups
                                  nil
                                  "Generating missing templates for Shared services group in progress"]
                    :description "Generating missing templates for Shared services group"
                    :text        "Engage"}]
     :headerless? true
     :id-func     :id
     :class       "align-middle xl:max-w-2-3"
     :cols        [[nil
                    (partial description tr)
                    {:class "mr-4"}]
                   [nil
                    (partial button tr)
                    {:width "150px"}]]}]])

(def separate-migration-views [[:view/admin.migration.backfill-planning-archiving-phases
                                "Backfill Planning archiving phases"]
                               [:view/admin.migration.link-acceptances-to-sub-reviews
                                "Link review acceptances to sub-reviews"]
                               [:view/admin.migration.bill-modified-ts
                                "Add bill modification timestamp"]
                               [:view/admin.migration.inspection-template-visit-type
                                "Update visit types to inspection types"]
                               [:view/admin.migration.fix-brantford-ids
                                "Fix Brantford property integration IDs"]
                               [:view/admin.migration.fix-cashiers
                                "Update cashier authorizations with grants having right permissions"]
                               [:view/admin.migration.property-geojson
                                "Migrate old property shapes to GeoJSON"]
                               [:view/admin.migration.sub-review-modified-ts
                                "Add sub-review modification timestamp"]
                               [:view/admin.migration.uri-path-ids
                                "Generate URI path IDs for domain groups"]
                               [:view/admin.migration.remove-extra-cashier-authz
                                "Remove extra cashier authorizations from draft workspaces that are not visible to the group"]
                               [:view/admin.migration.enable-property-management-for-all-domains
                                "Enable property management for all domain groups"]
                               [:view/admin.migration.migrate-clerks-to-meeting-coordinators
                                "Migrate clerk users to meeting coordinator groups"]
                               [:view/admin.migration.create-default-agenda-templates
                                "Create default agenda templates for domain groups"]
                               [:view/admin.migration.copy-committee-templates-to-domain
                                "Copy committee templates to domain-level meeting agenda templates"]
                               [:view/admin.migration.move-committees-to-domain
                                "Move committees to domain groups"]
                               [:view/admin.migration.assign-domain-agenda-templates
                                "Assign domain-level agenda templates to committees"]
                               [:view/admin.migration.migrate-property-units
                                "Migrate property units from addresses"]
                               [:view/admin.migration.migrate-workspace-address-units
                                "Clean up unit information from workspace addresses"]
                               [:view/admin.migration.revert-migrate-workspace-address-units
                                "Revert workspace address unit migration"]
                               [:view/admin.migration.revert-migrate-property-units
                                "Revert property unit migration"]
                               [:view/admin.migration.correct-cr-work-type-category
                                "Correct work-type category in imported CRs"]
                               [:view/admin.migration.migrate-statcan-form-to-version-2
                                "Migrate Statcan form to version 2"]
                               [:view/admin.migration.add-domain-authority-users-as-domain-admins
                                "Add authority users for domain groups that are missing one"]
                               [:view/admin.migration.activate-verified-properties
                                "Set verified properties to active state"]
                               [:view/admin.migration.link-primary-addresses
                                "Link primary addresses to property addresses"]
                               [:view/admin.migration.activate-existing-addresses
                                "Set existing addresses active"]])

(defn one-time-migrations-tab []
  (let [tr (<sub [:tr])]
    [:<>
     [one-time-migrations-table tr]
     [acommon/section {:title "Migrations with dedicated pages"}
      [:div
       (futil/for-frag [[view-id link-text] separate-migration-views]
         [:div.mb-2
          (cc/link {:href (href/href view-id)}
                   link-text)])]]]))

(defn view [match]
  (let [tr       (<sub [:tr])
        ai-chat? (<sub [::ff/enabled? :feature-flag.id/ai-chat])]
    [acommon/admin-page-v2
     (util/mmap {:title (tr [:admin-tools/commands])
                 :tabs  (concat [["Tools" tools-view]
                                 ["One-time migrations" one-time-migrations-tab]
                                 ["Search index ops" (fn [] [elasticsearch-ops tr])]
                                 ["Infrastructure ops" (fn [] [:div
                                                               [datomic-ops tr]
                                                               [postgresql-ops tr]
                                                               [storage-ops tr]])]
                                 ["Query Analyzer" query-analyzer/query-analyzer-panel]]
                                (when ai-chat? [["Freshdesk Articles" freshdesk/freshdesk-panel]]))}
                match)]))

(def route
  {:name        :view/admin.commands
   :view-sub    [::view-data]
   :own-layout? true
   :view        view})
